import { Component, EventEmitter, Input, Output } from '@angular/core'

import { AuthService } from '@app/core/service/auth.service'
import { FeeItemInstance } from '@app/features/scope-overview/model/fee-item.model'
import { MenuOptions } from '@app/core/model/definitions/menu-options.interface'
import { Privilege } from '@app/core/model/enums/privilege.enum'
import { ScopeElementsService } from '../services/scope-elements.service'
import { ScopeElementsConfig } from '../models'
import { trackById } from '@shared/utils/utils'

@Component({ selector: 'scope-fees', templateUrl: './fees.component.html', styleUrls: ['./fees.component.scss'] })
export class FeesComponent {
  @Input() parent: any
  @Input() columns: any
  @Input() level: number
  @Input() tableStates: any
  @Input() config: ScopeElementsConfig
  @Input() feeMenuOptions: MenuOptions[]

  @Output() onUpdateFeeItem = new EventEmitter<FeeItemInstance>()

  constructor(
    protected authService: AuthService,
    protected scopeElementsService: ScopeElementsService
  ) {}

  protected readonly trackById = trackById
  protected readonly Privilege = Privilege
}
